<div class="mat-dialog-wrapper match-journal">
  <div class="d-flex justify-space-between align-items-center mb-5">
    <h2 mat-dialog-title class="m-0">VAT Audit Report</h2>

    <div class="d-flex gap-10">
      <div class="header-actions">
        <div class="toolbar">
          <button mat-button [matMenuTriggerFor]="menu" disableRipple>
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu
            #menu="matMenu"
            class="action-menu more-menu"
            xPosition="before"
          >
            <button mat-menu-item (click)="onPdfClick()" disableRipple>
              <mat-icon fontSet="material-icons-outlined">picture_as_pdf</mat-icon
              >Export As PDF
            </button>

            <button mat-menu-item (click)="onExcelClick()" disableRipple>
              <mat-icon>border_all</mat-icon>Export to Excel
            </button>
          </mat-menu>
        </div>
      </div>
      <button
        class="close-button"
        type="button"
        (click)="onCloseClick()"
        mat-button
        disableRipple
      >
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>
 
  <mat-dialog-content>    
    <div class="content-body p-0">
      <mat-tab-group
        *ngIf="!isFlatRate"
        mat-align-tabs="start"
        disableRipple
        animationDuration="0ms"
        animationDuration="0ms "
        [(selectedIndex)]="selectedTab"
        (selectedTabChange)="onTabClick($event.index)"
      >
        <mat-tab label="VAT Return">
          <div class="mat-table-wrapper mt-1">
            <mat-table #table [dataSource]="vatReturnDataSource">
              <ng-container matColumnDef="boxNo">
                <mat-header-cell *matHeaderCellDef class="mxw-120"> <div class="white-space-nowrap">Box No.</div> </mat-header-cell>
                <mat-cell *matCellDef="let element" class="mxw-120">
                  <div class="white-space-nowrap">{{ element.boxNo }}</div>
                </mat-cell>
              </ng-container>
              <ng-container matColumnDef="vatDesc">
                <mat-header-cell *matHeaderCellDef>
                  VAT Description
                </mat-header-cell>
                <mat-cell *matCellDef="let element">
                  {{ element.vatDesc }}
                </mat-cell>
              </ng-container>
              <ng-container matColumnDef="vatAmount">
                <mat-header-cell *matHeaderCellDef class="justify-content-end mxw-120">
                  Amount
                </mat-header-cell>
                <mat-cell *matCellDef="let element" class="justify-content-end mxw-120">
                  <div class="white-space-nowrap">£ {{ element.vatAmount | numberPipe }}</div>
                </mat-cell>
              </ng-container>
              <mat-header-row
                *matHeaderRowDef="vatReturnDisplayedColumns; sticky: true"
              ></mat-header-row>
              <mat-row
                *matRowDef="let row; columns: vatReturnDisplayedColumns"
              ></mat-row>
            </mat-table>
            <div *ngIf="noDataFound" class="text-align-center mt-1 fw-bold">
              No Data Found
            </div>
          </div>
        </mat-tab>
        <mat-tab label="Sales VAT" *ngIf="!this.vatReturnList.isBridgingVAT">
          <app-vat-view-data
            *ngIf="selectedTab === 1"
            [tabSalesPurchase]="selectedTab"
            [vatReturnId]="id"
          >
          </app-vat-view-data>
        </mat-tab>
        <mat-tab label="Purchase VAT" *ngIf="!this.vatReturnList.isBridgingVAT">
          <app-vat-view-data
            *ngIf="selectedTab === 2"
            [tabSalesPurchase]="selectedTab"
            [vatReturnId]="id"
          >
          </app-vat-view-data>
        </mat-tab>
        <!-- <mat-tab label="Sales No VAT" *ngIf="!this.vatReturnList.isBridgingVAT">
          <app-vat-view-data
            *ngIf="selectedTab === 3"
            [tabSalesPurchase]="selectedTab"
            [vatReturnId]="id"
          >
          </app-vat-view-data>
        </mat-tab>
        <mat-tab
          label="Purchase No VAT"
          *ngIf="!this.vatReturnList.isBridgingVAT"
        >
          <app-vat-view-data
            *ngIf="selectedTab === 4"
            [tabSalesPurchase]="selectedTab"
            [vatReturnId]="id"
          >
          </app-vat-view-data>
        </mat-tab> -->
      </mat-tab-group>

      <mat-tab-group
        (selectedTabChange)="selectedTabValue($event)"
        *ngIf="isFlatRate"
      >
        <mat-tab label="VAT Return">
          <app-vat-return-data
            [vatReturnData]="vatReturnDataSource"
          ></app-vat-return-data>
        </mat-tab>
        <mat-tab label="{{ returnsList[0]?.subreturnDate }}">
          <mat-tab-group
            mat-align-tabs="start"
            disableRipple
            animationDuration="0ms"
            animationDuration="0ms "
            [(selectedIndex)]="selectedTab"
            (selectedTabChange)="onTabClick($event.index)"
          >
            <mat-tab label="VAT Return">
              <app-vat-return-data
                [vatReturnData]="vatReturnDataSource"
              ></app-vat-return-data>
            </mat-tab>
            <mat-tab
              label="Sales VAT"
              *ngIf="!this.vatReturnList.isBridgingVAT"
            >
              <app-vat-view-data
                *ngIf="selectedTab === 1 && subTab === 1"
                [tabSalesPurchase]="selectedTab"
                [vatReturnId]="subreturnId"
              >
              </app-vat-view-data>
            </mat-tab>
            <mat-tab
              label="Purchase VAT"
              *ngIf="!this.vatReturnList.isBridgingVAT"
            >
              <app-vat-view-data
                *ngIf="selectedTab === 2 && subTab === 1"
                [tabSalesPurchase]="selectedTab"
                [vatReturnId]="subreturnId"
              >
              </app-vat-view-data>
            </mat-tab>
            <mat-tab
              label="Sales No VAT"
              *ngIf="!this.vatReturnList.isBridgingVAT"
            >
              <app-vat-view-data
                *ngIf="selectedTab === 3 && subTab === 1"
                [tabSalesPurchase]="selectedTab"
                [vatReturnId]="subreturnId"
              >
              </app-vat-view-data>
            </mat-tab>
            <mat-tab
              label="Purchase No VAT"
              *ngIf="!this.vatReturnList.isBridgingVAT"
            >
              <app-vat-view-data
                *ngIf="selectedTab === 4 && subTab === 1"
                [tabSalesPurchase]="selectedTab"
                [vatReturnId]="subreturnId"
              >
              </app-vat-view-data>
            </mat-tab>
          </mat-tab-group>
        </mat-tab>
        <mat-tab label="{{ returnsList[1]?.subreturnDate }}">
          <mat-tab-group
            mat-align-tabs="start"
            disableRipple
            animationDuration="0ms"
            animationDuration="0ms "
            [(selectedIndex)]="selectedTab"
            (selectedTabChange)="onTabClick($event.index)"
          >
            <mat-tab label="VAT Return">
              <app-vat-return-data
                [vatReturnData]="vatReturnDataSource"
              ></app-vat-return-data>
            </mat-tab>
            <mat-tab
              label="Sales VAT"
              *ngIf="!this.vatReturnList.isBridgingVAT"
            >
              <app-vat-view-data
                *ngIf="selectedTab === 1 && subTab === 2"
                [tabSalesPurchase]="selectedTab"
                [vatReturnId]="subreturnId"
              >
              </app-vat-view-data>
            </mat-tab>
            <mat-tab
              label="Purchase VAT"
              *ngIf="!this.vatReturnList.isBridgingVAT"
            >
              <app-vat-view-data
                *ngIf="selectedTab === 2 && subTab === 2"
                [tabSalesPurchase]="selectedTab"
                [vatReturnId]="subreturnId"
              >
              </app-vat-view-data>
            </mat-tab>
            <mat-tab
              label="Sales No VAT"
              *ngIf="!this.vatReturnList.isBridgingVAT"
            >
              <app-vat-view-data
                *ngIf="selectedTab === 3 && subTab === 2"
                [tabSalesPurchase]="selectedTab"
                [vatReturnId]="subreturnId"
              >
              </app-vat-view-data>
            </mat-tab>
            <mat-tab
              label="Purchase No VAT"
              *ngIf="!this.vatReturnList.isBridgingVAT"
            >
              <app-vat-view-data
                *ngIf="selectedTab === 4 && subTab === 2"
                [tabSalesPurchase]="selectedTab"
                [vatReturnId]="subreturnId"
              >
              </app-vat-view-data>
            </mat-tab>
          </mat-tab-group>
        </mat-tab>
      </mat-tab-group>
    </div>
  </mat-dialog-content>
</div>

<app-custom-notifications></app-custom-notifications>
